import { useRef, useState } from 'react';

const SearchIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
    <path d="M16 16l4.5 4.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

const PageFilterSearch = ({ className = '', inputRef, children }) => {
  const fallbackRef = useRef(null);
  const resolvedRef = inputRef || fallbackRef;
  const [open, setOpen] = useState(false);

  const handleIconClick = () => {
    setOpen((value) => !value);
    const input = resolvedRef.current;
    if (input) {
      window.requestAnimationFrame(() => input.focus());
    }
  };

  return (
    <div className={`page-filter-search${open ? ' page-filter-search--open' : ''}${className ? ` ${className}` : ''}`}>
      <button
        type="button"
        className="page-filter-icon-btn page-filter-search-btn"
        aria-label="Search"
        aria-expanded={open}
        onClick={handleIconClick}
      >
        <SearchIcon />
      </button>
      {typeof children === 'function' ? children(resolvedRef) : children}
    </div>
  );
};

export default PageFilterSearch;
